import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {BlockStore} from '@blocks/block/block.store';
import {BLOCKS_CONFIG, BlocksConfig} from '@blocks/blocks.config';
import {FormMetaInformation} from '../form-meta-information';
import {Router} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {BlocksModule} from '@blocks/blocks.module';
import {AsyncPipe, NgForOf} from '@angular/common';

@Component({
  selector: 'app-forms-preview',
  templateUrl: './forms-preview.component.html',
  styleUrls: ['./forms-preview.component.scss'],
  providers: [
    {
      provide: BLOCKS_CONFIG,
      useValue: new BlocksConfig({excludable: false, editable: false, preview: true})
    }
  ],
  imports: [
    FormsModule,
    BlocksModule,
    NgForOf,
    AsyncPipe
  ],
  standalone: true
})
export class FormsPreviewComponent {
  @Input() formMetaInformation: FormMetaInformation;
  @Input() publicToken: string;

  @Output() start = new EventEmitter();

  blockStore = inject(BlockStore);
  router = inject(Router);

  pages$ = this.blockStore.pages();
}
